import jwtDecode from 'jwt-decode'

export const LOCAL_STORAGE_TOKEN_KEY = 'reggora_lender_auth_token'

export const tokenService = {
  /**
   * Get token synchronously
   * @deprecated Use getTokenAsync instead
   * @returns {string|null} The token from localStorage or null if not found
   */
  getToken: () => {
    return localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)
  },
  /**
   * Get token asynchronously
   * @returns {Promise<string|null>} A promise that resolves to the token from localStorage or null if not found
   */
  getTokenAsync: async () => {
    return localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)
  },

  /**
   * Set token in storage
   * @param {string} token
   */
  setToken: (token) => {
    localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token)
  },

  /**
   * Remove token from storage
   * @returns {void}
   * Removes the token from localStorage
   */
  removeToken: () => {
    localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY)
  },

  /**
   * Check if token is valid (not expired)
   * @param {string|null} token
   * @returns {boolean}
   */
  isTokenValid: (token) => {
    if (!token) { return false }

    try {
      const decoded = jwtDecode(token)
      const now = new Date()
      // exp unix seconds, date is in milliseconds
      const expirationDate = new Date(decoded.exp * 1000)

      return !decoded.error && now < expirationDate
    } catch (err) {
      return false
    }
  },
}


export const tokenUtils = {

  /**
   * Get user ID from token
   * @param {string|null} token
   * @returns {string|undefined}
   */
  getUserIDFromToken: (token) => {
    try {
      const decodedValue = jwtDecode(token)
      return decodedValue?.user_id
    } catch (err) {
      return undefined
    }
  },
}
